import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../../../../collection'
import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * Retrieves the count of entities that match the given request
 */
export const executeCount = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    collection: Collection<TTypeParams>,
  ) => {
    // TODO: in certain cases, we should be able to count items locally
    // depending on the listQueryRequestUsage

    const canCount = collection.plugins.apiExecutionPlugin.canExecute('count')
    const listQueryRequestUsage =
      collection.plugins.apiExecutionPlugin.listQueryRequestUsage
    if (!canCount) {
      return undefined
    }

    return feature.actions.count.relay((forwardTo, request) =>
      collection.feature.selectors.context.asObservable.pipe(
        // We need to get the context, but just the most recent value
        rxjs.take(1),
        rxjs.map(context =>
          forwardTo(
            collection.plugins.apiExecutionPlugin.feature.actions.execute,
            {
              input: {
                args: [request],
                context,
                methodName: 'count',
              },
              output: ({ response }) =>
                // NOTE: since `execute` can return a variety of
                // results, we need to tell TypeScript which result we
                // expect
                response as rxjs.ObservedValueOf<
                  ecModels.Api.Method.Result<'count', typeof collection.api>
                >,
            },
          ),
        ),
      ),
    ).asObservable
  },
)
